var mapTypeToLabel = {
    'freeDelivery': 'Darmowa dostawa',
    'same-category': 'Rabat na drugi produkt w kategorii',
    'product': 'Rabat na konkretny product',
    'promo_code_value': 'Rabat za użycie kodu',
    'takeout': 'Rabat za odbiór osobisty',
};
var getDiscountItemLabel = function (item) {
    return mapTypeToLabel[item.type] || 'Rabat';
};
var Discount = {
    getDiscountItemLabel: getDiscountItemLabel,
};
export default Discount;
